
export async function doDraw(diagramInput, showGrid) {
    return new Promise((resolve) => {
        // This timeout is necessary to give the browser's main thread the opportunity to
        // update the UI elements before getting blocked in the WASM call
        setTimeout(() => {
        const result = draw(diagramInput, showGrid);
        resolve(result);
        }, 100);
    });
}
